import Layout from "../../containers/Layout";
import BoxInfoTemplate from "../BoxInfoTEmplate/BoxInfoTemplate";
import Seo from "../Seo/Seo";

const NotFoundPage = () => {
  return (
    <Layout mt={16}>
      <Seo title="Page Not Found" noIndex />
      <BoxInfoTemplate
        title="404"
        subTitle="Page not found"
        mainText="Oops… it looks like this page got lost somewhere between subjunctives and prepositions."
        iconType="alert"
        showQuotes={false}
        showShadow={true}
        borderColor="red"
      />
    </Layout>
  );
};

export default NotFoundPage;
